import { useMutation } from '@tanstack/react-query';
import { GET, GET_BARCORE } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';
import { navigateTo } from '../../../utils/navigation';
import { ROUTES_PATH } from '../../../resources/routes-name';
import { useDispatch } from 'react-redux';
import { setRegisterProductData } from '../../../redux/registerProduct/action';

export const useBarcodeQuery = ({ reset, getValues }) => {
  const dispatch = useDispatch();
  const { mutate, isPending } = useMutation({
    mutationFn: async (value) => {
      const response = await GET(GET_BARCORE(value));
      return response.result.item;
    },
    onSuccess: (result) => {
      openAlert({
        type: 'success',
        model: 'message',
        message: 'ค้นหาสินค้าสำเร็จ',
      });
      dispatch(
        setRegisterProductData({
          ...result,
        }),
      );
      setTimeout(() => {
        navigateTo({
          pathname: ROUTES_PATH.ROUTE_REGISTER_PRODUCT.PATH,
        });
      }, 1500);
    },
    onError: (result) => {
      reset({
        ...getValues(),
        ...result,
      });
    },
  });
  return { mutate, loading: isPending };
};
